import axios from "axios";
import { AuthSessionManager } from "../auth/AuthSessionManager";
import { dispatchHttpError } from "./errors/errorDispatcher";

export const silentPollingConfig = {
  skipGlobalErrorDispatch: true,
};

function isAuthenticationHttpError(status, message) {
  if (status === 401) return true;
  if (status === 403) {
    const normalized = String(message ?? "").toLowerCase();
    if (
      normalized.includes("impersonific") ||
      normalized.includes("sola lettura") ||
      normalized.includes("non è consentita") ||
      normalized.includes("vendor non trovato") ||
      normalized.includes("vendor account") ||
      normalized.includes("non attivo") ||
      normalized.includes("in attivazione") ||
      normalized.includes("sospeso")
    ) {
      return false;
    }
    return true;
  }
  const normalized = String(message ?? "").toLowerCase();
  return (
    normalized.includes("autenticazione non valida") ||
    normalized.includes("sessione scaduta") ||
    normalized.includes("token scaduto")
  );
}

function dispatchAuthSessionInvalid() {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new Event("wcp:auth:session-invalid"));
}

export const httpClient = axios.create();

// interceptor per unificazione auth e gestione errori
httpClient.interceptors.request.use((config) => {
  // skip auth per chiamate pubbliche
  if (config && config.skipAuth === true) return config;

  const token = AuthSessionManager.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token.startsWith("Bearer ")
      ? token
      : `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    const skipGlobal = error?.config?.skipGlobalErrorDispatch === true;
    const status = error?.response?.status;
    const message = error?.response?.data?.message ?? error?.message ?? "HTTP error";

    if (isAuthenticationHttpError(status, message)) {
      dispatchAuthSessionInvalid();
      return Promise.reject(error);
    }

    if (!skipGlobal) {
      dispatchHttpError({
        status,
        message,
        data: error?.response?.data,
        url: error?.config?.url,
        method: error?.config?.method,
        stack: error?.stack,
      });
    }
    return Promise.reject(error);
  }
);

